/**
 * Socket 包数据处理工具.
 *
 * 数据组成:
 * [数据长度: UShort]
 * [协议Id: Short]
 * [数据: 数据长度]
 * 包总大小: 2 + 2 + DataBufferLength = 4 + DataBufferLength
 */
/* eslint-disable */
import { SocketPackTool } from "./SocketPackTool";

export const SendPackBufferLengthMax = 1024 * 64; // 64k
export const RecvPackBufferLengthMax = 1024 * 64 * 100; // 64K * 100
//export const DataBufferLengthSkew                  = 4;

export namespace PackDataByteOffset {
  export const DataLength = 0; // 数据长度: int
  export const ProtobufId = 4; // 协议Id: Short
  export const ErrorCode = 6; // 错误码  Short
  export const Data = 8; // 数据
}

export class UnpackData {
  public protobufId: number;
  public pack: any;
  public code: number;

  constructor(_protobufId: number, _pack: any, code: number) {
    this.protobufId = _protobufId;
    this.pack = _pack;
    this.code = code;
  }
}

export class SocketDataTool {
  private sendBuffer: ArrayBuffer;
  private recvBuffer: ArrayBuffer;

  private sendDataView: DataView;
  private recvDataView: DataView;

  private recvBufferLength: number;

  constructor() {
    this.sendBuffer = new ArrayBuffer(SendPackBufferLengthMax);
    this.recvBuffer = new ArrayBuffer(RecvPackBufferLengthMax);

    this.sendDataView = new DataView(this.sendBuffer);
    this.recvDataView = new DataView(this.recvBuffer);

    this.recvBufferLength = 0;
  }

  /**
   * 数据封包
   *
   * @param packetId
   * @param logicId
   * @param dataBuf
   */
  public pack(packetId: number, dataBuf: Uint8Array): ArrayBuffer {
    const dataByteLength = dataBuf.byteLength;
    const packByteLength = PackDataByteOffset.Data + 4 + dataBuf.byteLength;

    // 头部  获取数据长度
    this.sendDataView.setUint32(PackDataByteOffset.DataLength, packByteLength);
    //服务器自增的NumId
    this.sendDataView.setUint16(PackDataByteOffset.ProtobufId, packetId);
    //错误码 （不合理）后期需要移除
    this.sendDataView.setInt16(PackDataByteOffset.ErrorCode, packetId);
    //服务端奇怪的要求 添加一个seq int数据
    this.sendDataView.setInt32(PackDataByteOffset.Data, packByteLength);
    // 数据最低1个字符
    for (let i = 0; i < dataByteLength; i++) {
      this.sendDataView.setUint8(PackDataByteOffset.Data + 4 + i, dataBuf[i]);
    }

    // 返回一个新的数据
    return this.sendDataView.buffer.slice(0, packByteLength);
  }

  public recvData(data: ArrayBuffer): void {
    // 新数据加入到缓存中
    const dataView = new DataView(data);
    for (let i = 0; i < data.byteLength; i++) {
      this.recvDataView.setUint8(
        this.recvBufferLength + i,
        dataView.getUint8(i)
      );
    }
    this.recvBufferLength += data.byteLength;
  }

  public unpack(): UnpackData | undefined {
    // 数据包头数据是否完整
    if (this.recvBufferLength < PackDataByteOffset.Data) {
      return undefined;
    }

    // 数据包数据部分是否完整
    const dataBufferLength = this.recvDataView.getUint32(
      PackDataByteOffset.DataLength
    );
    const packByteLength = dataBufferLength;
    if (
      this.recvBufferLength <
      dataBufferLength + PackDataByteOffset.DataLength
    ) {
      return undefined;
    }

    // 整个包数据
    const packDataBuffer = this.recvDataView.buffer.slice(0, packByteLength);

    // 剩余数据前移
    this.recvBufferLength -= packByteLength;
    if (this.recvBufferLength > 0) {
      for (let i = 0; i < this.recvBufferLength; i++) {
        this.recvDataView.setUint8(
          i,
          this.recvDataView.getUint8(packByteLength + i)
        );
      }
    }

    // 解包数据
    return this.unpackData(packDataBuffer);
  }

  /**
   * 数据解包
   *
   * @param packDataBuffer
   */
  private unpackData(packDataBuffer: ArrayBuffer): UnpackData | undefined {
    const packDataView = new DataView(packDataBuffer);
    const dataExpectByteLength = packDataView.getUint32(
      PackDataByteOffset.DataLength
    );
    const dataByteLength = packDataBuffer.byteLength;
    if (dataExpectByteLength !== dataByteLength) {
      return undefined;
    }
    //
    const protobufId = packDataView.getInt16(PackDataByteOffset.ProtobufId);
    const errorCode = packDataView.getInt16(PackDataByteOffset.ErrorCode);
    // 数据最低1个字符8字节
    const dataView = new DataView(new ArrayBuffer(dataByteLength - 8));
    for (let i = 0; i < dataByteLength - PackDataByteOffset.Data; i++) {
      dataView.setUint8(i, packDataView.getUint8(PackDataByteOffset.Data + i));
    }
    const unpackFunc = SocketPackTool.getUnpackFunc(protobufId);
    let data: any = undefined;
    const uInt8Arr = new Uint8Array(dataView.buffer);
    if (unpackFunc !== undefined) {
      data = unpackFunc.decode(uInt8Arr);
    }
    return new UnpackData(protobufId, data, errorCode);
  }
}
